export const TASK = {
  task: 'Task',
  tasks: 'Tasks',
  newTask: 'New task',
  updateTask: 'Edit task',
  deleteTask: 'Delete task',
  deleteTasks: 'Delete tasks',
  // Composed rather than concatenated from GLOBAL.deleteItemText, which only
  // has a singular form — "delete this Tasks?" read as a bug.
  deleteTaskConfirm: 'Are you sure you want to delete this task?',
  deleteTasksConfirm: 'Are you sure you want to delete these tasks?',
  selectOwner: 'Select owner',
  selectContributor: 'Select contributors',
  bulkAdd: 'Bulk add',
  addTasksOnePerLine: 'Add tasks - One per line',
  createTask: 'Create task',

  // --- Quick add ---
  addTaskPlaceholder: 'Add a task — it starts as Pending',
  addTask: 'Add task',
  addTasks: 'Add tasks',
  linesDetected: 'separate tasks will be created, one per line',
  bulkLimitReached: 'Only the first 100 tasks will be added',

  // --- List ---
  allTasks: 'All',
  noOwner: 'No owner',
  unassigned: 'Unassigned',
  you: 'You',
  setStatus: 'Set status',
  moreActions: 'More actions',
  selectTask: 'Select task',
  selectAllTasks: 'Select all tasks',
  overdueWasDue: 'Overdue — was due',
  updated: 'Updated',
  updatedToday: 'Updated today',
  updatedAgo: 'ago',
  showingFirstPage: 'Showing the first 100 tasks — counts describe this page',

  // --- Empty states ---
  noTasksYet: 'No tasks yet. Add the first one above.',
  nothingPending: 'Nothing pending — everything has been picked up.',
  nothingInProgress: 'Nothing in progress right now.',
  noTasksCompleted: 'No tasks completed yet.',
  nothingClosed: 'Nothing has been closed.',

  // --- Team this week ---
  teamThisWeek: 'The team this week',
  ofCompleted: 'completed',
  allCompleted: 'All completed',
  notStarted: 'Not started',
  needsAnUpdate: 'Needs an update',
  everyoneCurrent: "Everyone's current — nothing to chase",
  itemNeedsFollowUp: 'item needs a follow-up',
  itemsNeedFollowUp: 'items need a follow-up',

  // --- Weekly review ---
  weeklyReview: 'Weekly review',
  weeklyReviewNotSaved:
    'The recap is not saved — only the status changes you pick are written.',
  weeklyReviewEmpty: 'Nothing needs reviewing. The board is current.',
  step: 'Step',
  of: 'of',
  recap: 'Recap',
  decision: 'Decision',
  recapNotePlaceholder: 'Add a line for the recap (optional)',
  landADecision: 'Land a decision before moving on',
  quickConfirmation: 'Quick confirmation',
  decisionsRecorded: 'decisions recorded',
  noDecisionRecorded: 'No decision recorded',
  anythingNew: 'Anything new from this meeting?',
  addTaskTeamAgreed: 'Add a task the team agreed to',
  finishReview: 'Finish review',
  back: 'Back',
  next: 'Next',
  noRecentChange: 'No recent change',
  noStatusChangeIn: 'No status change in',
  overdue: 'Overdue',
  overdueBy: 'Overdue by',
  chaseTheDate: 'Agree a new date, or close it out',
  confirmStatusOutLoud: 'Confirm the status out loud so the board stays honest',
  nameTheWin: 'Name the win — then move on',
  newTasksAdded: 'new tasks added',

  // --- Weekly review decisions ---
  stillOnTrack: 'Still on track',
  notStartedYet: 'Not started yet',
  startItThisWeek: 'Start it this week',
  moveTheDate: 'Move the date',
  closeIt: 'Close it',
  noted: 'Noted',

  // --- v4 design: rendered but not yet wired to an API ---
  filters: 'Filters',
  blocked: 'Blocked',
  block: 'Mark as blocked',
  unblock: 'Unblock',
  blockedReason: 'Blocked — needs attention before it can move.',
  blockTask: 'Block task',
  blockReasonLabel: 'Why is this task blocked?',
  blockReasonPlaceholder: 'Describe what is stopping this task from moving',
  blockReason: 'Reason',
  blockedTask: 'Blocked task',
  unblockTask: 'Unblock task',
  viewBlockedReason: 'view reason',
  addPeople: 'Add people',
  nudge: 'Nudge',

  // --- Comments ---
  comment: 'comment',
  commentsLower: 'comments',
  openComments: 'open comments',
  noCommentsYet: 'No comments yet. Start the conversation.',
  loadCommentsFailed: "Comments couldn't be loaded.",
  retry: 'Retry',
  addComment: 'Add a comment',
  editComment: 'Edit comment',
  commentActions: 'Comment actions',
  reply: 'Reply',
  replyLower: 'reply',
  repliesLower: 'replies',
  replyingTo: 'Replying to',
  cancelReply: 'Cancel reply',
  edited: '(edited)',
  editedOn: 'Edited',
  unknownUser: 'Unknown user',
  showMore: 'Show more',
  save: 'Save',
  deleteComment: 'Delete comment',
  deleteCommentConfirm: 'Delete this comment?',
  // Composed as "Its {n} {reply will|replies will} also be hidden."
  deleteCommentIts: 'Its',
  deleteCommentReplyHidden: 'reply will also be hidden.',
  deleteCommentRepliesHidden: 'replies will also be hidden.',
  cannotBeUndone: "This can't be undone.",
  discardUnsavedComment: 'Discard unsaved comment?',
  discardUnsavedCommentBody: 'What you typed will be lost.',
  discard: 'Discard',
  keepEditing: 'Keep editing',
  commentWasDeleted: 'That comment was deleted',
  taskNoLongerExists: 'This task no longer exists',
} as const
